import { TX } from '../registry/keys';

/** Explicit tools for the on-screen palette. "auto" keeps the smart
 *  context-sensitive tap; the rest force a specific action on the tapped tile. */
export type ToolId = 'auto' | 'hoe' | 'water' | 'axe' | 'scythe' | 'move' | 'rod';

export interface ToolDef {
  id: ToolId;
  name: string;
  icon: string;
  hint: string;
}

export const TOOLS: ToolDef[] = [
  { id: 'auto', name: 'Auto', icon: TX.toolHand, hint: 'Smart tap — does the obvious thing.' },
  { id: 'hoe', name: 'Hoe', icon: TX.toolHoe, hint: 'Till grass into farm soil.' },
  { id: 'water', name: 'Water', icon: TX.toolWater, hint: 'Water your planted crops.' },
  { id: 'axe', name: 'Axe', icon: TX.toolAxe, hint: 'Chop a tree for wood.' },
  { id: 'scythe', name: 'Scythe', icon: TX.toolScythe, hint: 'Clear weeds.' },
  { id: 'move', name: 'Move', icon: TX.toolMove, hint: 'Pick up a placed item to move it.' },
  { id: 'rod', name: 'Fish', icon: TX.toolRod, hint: 'Fish at the pond.' },
];

export const getTool = (id: ToolId): ToolDef | undefined => TOOLS.find((t) => t.id === id);
